module.exports = __webpack_public_path__ + "img/telttailupaikka_original.2fbf02bc.jpg";